/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Gateway_Sub_Plan_Card_StorageInputs */



/**
* | output |
* | --- |
* | "{size} storage" |
*
* @param {Gateway_Sub_Plan_Card_StorageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_plan_card_storage = /** @type {((inputs: Gateway_Sub_Plan_Card_StorageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Plan_Card_StorageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.size} Speicher`)
	return /** @type {LocalizedString} */ (`${i?.size} storage`)
});